<template>
  <div>    
    <div ref="printArea" class="printable">
    <v-simple-table dense fixed-header height="60vh" >
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Tarih</th>
            <th class="text-left">Belge No</th>
            <th class="text-left">ACIKLAMA</th>            
            <th class="text-left">Borç</th>
            <th class="text-left">Alacak</th>            
            <th class="text-left">Borç Bakiye</th>
            <th class="text-left">Alacak Bakiye</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in CurrentData.CariHareket" :key="item.FIS_NO">
            <td>{{ new Date(item.TARIH).toLocaleDateString("tr-TR") }}</td>
            <td>
              {{ item.FIS_NO }}
            </td>
            <td>{{ item.ACIKLAMA }}</td>
            <td>{{ item.BORC }}</td>
            <td>{{ item.ALACAK }}</td>
            <td style="color:red">{{ item.BORC_BAKIYE }}</td>
            <td style="color:green">{{ item.ALACAK_BAKIYE }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    
<v-row class="mb-2" align="center" justify="space-between">
    <v-col cols="auto">
      <button @click="printTable" class="print-button">
        <i class="fas fa-print"></i> Yazdır
      </button>
    </v-col>
    <v-col cols="auto">
      <v-card class="pa-2">
        <b>Toplam :</b>
        <span style="color: red">{{ CurrentData.Toplam }}₺</span>
      </v-card>
    </v-col>
  </v-row>
    </div>
  </div>
</template>
<script>
export default {
  data: () => ({
    CurrentData: {
      CariHareket: [],
    },
  }),
  mounted() {
    this.GetCurrDetail();
  },
  methods: {
    GetCurrDetail() {
      let thisvue = this;
      this.$http
        .get(this.$base + "/Current/", {
          headers: {
            Authorization: `Bearer ${thisvue.Auth.auth.accessToken}`,
          },
        })
        .then(function (response) {
          thisvue.CurrentData = response.data;
          console.log(response.data);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    printTable() {
   window.print();
  }
  },
  computed: {
    Auth() {
      return this.$store.getters.getAuth;
    },
  },
};
</script>
<style scoped>
* {
  box-shadow: none !important;
}

</style>
<style>
@media print {
  body * { visibility: hidden !important; }
  .printable, .printable * { visibility: visible !important; }
  .printable { position: absolute; top: 0; left: 0; }
  .v-data-table__wrapper {
    height: auto !important;
    max-height: none !important;
    overflow: visible !important;
    /* isterseniz full viewport da yapabilirsiniz: */
    /* height: 100vh !important; */
  }
  .print-button {
    display: none;
  }
}

.print-button {
  background: linear-gradient(90deg, #4facfe 0%, #00f2fe 100%);
  color: #ffffff;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-weight: 500;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  transition: background 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
}

.print-button:hover {
  background: linear-gradient(90deg, #00f2fe 0%, #4facfe 100%);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

</style>